import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Clock } from 'lucide-react';
import { getBackendUrl } from '../../utils/api';

const BACKEND_URL = getBackendUrl();
const API = `${BACKEND_URL}/api`;

export const MasterActionLogsContent = () => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filterType, setFilterType] = useState('');

  useEffect(() => {
    fetchLogs();
  }, [page, filterType]);

  const fetchLogs = async () => {
    try {
      setLoading(true);
      const params = { page, page_size: 50 };
      if (filterType) params.action_type = filterType;
      
      const response = await axios.get(`${API}/master/action-logs`, { params });
      setLogs(response.data.logs);
      setTotalPages(response.data.total_pages);
      setLoading(false);
    } catch (error) {
      console.error('Error fetching logs:', error);
      setLoading(false);
    }
  };

  const actionTypeLabels = {
    suspend: '🔴 Suspender',
    activate: '🟢 Ativar',
    update_expiry: '📅 Atualizar Vencimento',
    update_notes: '📝 Atualizar Notas',
    impersonate: '👤 Acessar Painel',
    create_template: '➕ Criar Template',
    update_template: '✏️ Atualizar Template',
    delete_template: '🗑️ Deletar Template',
    apply_template: '✅ Aplicar Template'
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center py-12">
        <div className="loading-spinner"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <div>
          <h1 className="text-3xl font-bold text-white">Histórico de Ações</h1>
          <p className="text-gray-400 mt-1">Registro de todas as ações do master admin</p>
        </div>
        <select
          value={filterType}
          onChange={(e) => {
            setFilterType(e.target.value);
            setPage(1);
          }}
          className="glass-input"
        >
          <option value="">Todas as ações</option>
          <option value="suspend">Suspensões</option>
          <option value="activate">Ativações</option>
          <option value="update_expiry">Vencimentos</option>
          <option value="impersonate">Acessos</option>
          <option value="update_notes">Notas</option>
        </select>
      </div>

      {/* Logs Timeline */}
      <div className="glass-card">
        <div className="space-y-3">
          {logs.map((log) => (
            <div key={log.id} className="flex items-start gap-4 p-4 bg-gray-800/50 rounded-lg hover:bg-gray-800 transition-colors">
              <div className="flex-shrink-0">
                <Clock className="w-5 h-5 text-gray-400" />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-3 mb-1">
                  <span className="text-sm font-medium text-white">
                    {actionTypeLabels[log.action_type] || log.action_type}
                  </span>
                  {log.restaurant_name && (
                    <span className="text-sm text-blue-400">
                      {log.restaurant_name}
                    </span>
                  )}
                </div>
                <p className="text-sm text-gray-400">{log.description}</p>
                <p className="text-xs text-gray-500 mt-1">
                  {new Date(log.created_at).toLocaleString('pt-BR')}
                </p>
              </div>
            </div>
          ))}
        </div>

        {/* Pagination */}
        {totalPages > 1 && (
          <div className="flex items-center justify-center gap-2 mt-6 pt-6 border-t border-gray-700">
            <button
              onClick={() => setPage(p => Math.max(1, p - 1))}
              disabled={page === 1}
              className="px-4 py-2 glass-button-primary disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Anterior
            </button>
            <span className="text-gray-400">
              Página {page} de {totalPages}
            </span>
            <button
              onClick={() => setPage(p => Math.min(totalPages, p + 1))}
              disabled={page === totalPages}
              className="px-4 py-2 glass-button-primary disabled:opacity-50 disabled:cursor-not-allowed"
            >
              Próxima
            </button>
          </div>
        )}
      </div>

      {logs.length === 0 && (
        <div className="glass-card text-center py-12">
          <Clock size={48} className="mx-auto text-gray-400 mb-4" />
          <h3 className="text-xl font-semibold text-white mb-2">Nenhuma ação registrada</h3>
          <p className="text-gray-400">O histórico de ações aparecerá aqui</p>
        </div>
      )}
    </div>
  );
};


// =============================================================================
// MASTER SYSTEM SETTINGS CONTENT - Global Mercado Pago Configuration
// =============================================================================
// WhatsApp API Config Component (Evolution API ou WAHA)
